import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { insights } from "src/types";

const initialState: insights.InsightsStateType = {
  insightsData: {
    data: null,
    loading: false,
    error: null,
  },
  insightLog: {
    data: null,
    loading: false,
    error: null,
  },
  insightsHistory: {
    data: {
      history: [],
      full_count: 0,
      page: 0,
      limit: 0,
    },
    loading: false,
    error: null,
  },
};

const insightsSlice = createSlice({
  name: "insights",
  initialState,
  reducers: {
    // Get Insights Data
    getInsightsDataRequest: (
      state: insights.InsightsStateType,
      action: PayloadAction<any>
    ) => {
      state.insightsData.loading = true;
      state.insightsData.error = null;
    },
    getInsightsDataSuccess: (
      state: insights.InsightsStateType,
      action: PayloadAction<any>
    ) => {
      state.insightsData.data = action.payload;
      state.insightsData.loading = false;
      state.insightsData.error = null;
    },
    getInsightsDataFailure: (
      state: insights.InsightsStateType,
      action: PayloadAction<any>
    ) => {
      state.insightsData.loading = false;
      state.insightsData.error = action.payload;
    },

    // Get Log Data
    getLogDataRequest: (
      state: insights.InsightsStateType,
      action: PayloadAction<any>
    ) => {
      state.insightLog.loading = true;
      state.insightLog.error = null;
    },
    getLogDataSuccess: (
      state: insights.InsightsStateType,
      action: PayloadAction<any>
    ) => {
      state.insightLog.data = action.payload;
      state.insightLog.loading = false;
      state.insightLog.error = null;
    },
    getLogDataFailure: (
      state: insights.InsightsStateType,
      action: PayloadAction<any>
    ) => {
      state.insightLog.loading = false;
      state.insightLog.error = action.payload;
    },

    // Get History
    getHistoryRequest: (
      state: insights.InsightsStateType,
      action: PayloadAction<any>
    ) => {
      state.insightsHistory.loading = true;
      state.insightsHistory.error = null;
    },
    getHistorySuccess: (
      state: insights.InsightsStateType,
      action: PayloadAction<any>
    ) => {
      state.insightsHistory.data.history = [
        ...state.insightsHistory.data.history,
        ...action.payload.history,
      ].filter(
        (item, index, self) => index === self.findIndex((t) => t.id === item.id)
      );
      state.insightsHistory.data.page = action.payload.page;
      state.insightsHistory.data.limit = action.payload.limit;
      state.insightsHistory.data.full_count = action.payload.full_count;
      state.insightsHistory.loading = false;
      state.insightsHistory.error = null;
    },
    getHistoryFailure: (
      state: insights.InsightsStateType,
      action: PayloadAction<any>
    ) => {
      state.insightsHistory.loading = false;
      state.insightsHistory.error = action.payload;
    },

    // Clear History Data
    clearHistoryData: (state: insights.InsightsStateType) => {
      state.insightsHistory.data = {
        history: [],
        full_count: 0,
        page: 0,
        limit: 0,
      };
      state.insightsHistory.loading = false;
      state.insightsHistory.error = null;
    },
  },
});

export const {
  // Get Insights Data
  getInsightsDataRequest,
  getInsightsDataSuccess,
  getInsightsDataFailure,

  // Get Log Data
  getLogDataRequest,
  getLogDataSuccess,
  getLogDataFailure,

  // Get History
  getHistoryRequest,
  getHistorySuccess,
  getHistoryFailure,

  // Clear History Data
  clearHistoryData,
} = insightsSlice.actions;

export default insightsSlice.reducer;
